import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    blockHeaderStyle: {
        textAlign: "center",
        fontWeight: "400",
        fontSize: "24px",
        padding: "1em",
        textDecoration: "underline"
    },
    subsBlockStyle: {
        display: "flex !important",
        padding: "1em 0em",
        //justifyContent: "space-between",
        alignItems: "center"
    },
    fieldMargin: {
        display: "flex !important",
        padding: "1em 0em",
        //justifyContent: "space-between",
        alignItems: "center"
    },
    horizontallabels: {
        fontSize: "14px",
        color: "rgb(54 55 55)",
        textTransform: "uppercase",
    },
    leftLabels: {
        fontSize: "14px",
    },
    rightLabels: {
        fontSize: "14px",
        fontWeight: "500"
    },
    staticLabelStyle: {
        //display: "flex",
        //alignItems: "center"
        marginTop: "1em"
    },
    badgeStyle: {
        //backgroundColor: "#4791b5",
        fontSize: "15px",
        marginBottom: "10px",
    },
    buttonClass: {
        borderRadius: "5px",
        width: "15%",
        //backgroundColor: "#216ba5",
    },
    cardStyle: {
        backgroundColor: "#0092e9",
        color: "white"
    },
    toastHeader: {
        justifyContent: "space-between", 
        fontSize: "16px", 
        backgroundColor: "#ffc107",
        color: "white",
        border: "none",
        padding: "1em"
      }
})

export default styles;